import React from 'react';
import PhoenixIcon from '@airasia/phoenix-components/components/Icon';
import PhoenixTheme from '@airasia/phoenix-components/components/Theme';
import { func, oneOf, string } from 'prop-types';
import { Variant } from '../../utils/constants';

const variants = {
  error: {
    color: 'orange',
  },
  success: {
    color: 'tertiary',
  },
  default: {
    color: 'greyDark',
  },
};

const Icon = ({
  variant,
  icon,
  color,
  fontsize,
  onClick,
  className,
  ...restProps
}) => {
  const props = {
    icon,
    fontsize,
    color: variant in variants ? variants[variant] : color,
  };
  return (
    <PhoenixTheme>
      <span onClick={onClick} className={className}>
        <PhoenixIcon {...props} {...restProps} />
      </span>
    </PhoenixTheme>
  );
};

Icon.propTypes = {
  variant: oneOf([Variant.Success, Variant.Error, Variant.Default]),
  icon: string,
  color: string,
  fontsize: string,
  onClick: func,
  className: string,
};

Icon.defaultProps = {
  variant: null,
  icon: null,
  color: 'greyDark',
  fontsize: 'titleNormal',
  onClick: () => {},
  className: null,
};

export default Icon;
